<template>
  <section class="sign-out animate__animated animate__slideInRight">
    <div class="container ">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <h1>{{userName}}</h1>
              <p class="lightText">{{userEmail}}</p>
              <button class="btn btn-login btn-block btn-signout" @click="logout">Sign out</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  created(){
    this.$store.dispatch('setActiveTitle', "Options")
  },
  methods: {
    logout(){
      swal({
        title: "Are you sure?",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      })
      .then((willDelete) => {
        if (willDelete) {
          this.$axios.delete('/logout')
            .then(res => {
              if(res.data.status == true){
                this.$cookies.remove('crm-token');
                this.$cookies.remove('crm-user-name');
                this.$cookies.remove('crm-user-email');
                this.$router.replace('/login');
                return;
              }
            })
            .catch(err => console.log(err));
        }
      });
    }
  },
  computed: {
    userName(){
      return this.$cookies.get('crm-user-name')
    },
    userEmail(){
      return this.$cookies.get('crm-user-email')
    }
  }
}
</script>